/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ROW_DELETED_CLASS } from '@gh/common-internal-shared';
import { DateTimeTypes, getRouteInitData, NumberTypes } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { SelectionModel } from '@gh/core-data';
import { FormMode, STYLES_FLEX_COLUMN_LAYOUT } from '@gh/core-ui';
import {
  buildDateTimeColumn,
  buildNumberColumn,
  GridDefinitionFactory,
  LayoutBasedGridDefinition,
} from '@gh/core-ui-grid';
import { keyBy } from 'lodash';
import { DrawDetailsChangeOrder, DrawDetailsStage } from '../../../resources/draw-details.model';

@Component({
  standalone: false,
  selector: 'gh-draw-details-payment-variation-list',
  templateUrl: 'draw-details-payment-variation-list.component.html',
  styles: [STYLES_FLEX_COLUMN_LAYOUT],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DrawDetailsPaymentVariationListComponent implements OnInit {
  @Input() mode: FormMode;
  @Input() changeOrders: DrawDetailsChangeOrder[];
  @Input() selected: SelectionModel;
  @Input() masterDrawRuleId: ID;

  @Output() select = new EventEmitter<SelectionModel>();

  gridDefinition: LayoutBasedGridDefinition;

  private stageIndex: Hash<DrawDetailsStage>;

  @Input()
  set stages(stages: DrawDetailsStage[]) {
    this.stageIndex = keyBy(stages, 'stageNumber');
  }

  get isViewMode(): boolean {
    return this.mode === FormMode.ViewMode;
  }

  constructor(private route: ActivatedRoute,
              private gridDefinitionFactory: GridDefinitionFactory) {

  }

  ngOnInit(): void {
    const { changeOrderGridLayout } = getRouteInitData(this.route);
    this.gridDefinition = this.gridDefinitionFactory.buildLayoutBased(
      {
        authorizedDate: buildDateTimeColumn(DateTimeTypes.ShortDate),
        amount: buildNumberColumn(NumberTypes.SignedPrice),
        amountWithGst: buildNumberColumn(NumberTypes.SignedPrice),
        gstAmount: buildNumberColumn(NumberTypes.SignedPrice),
      },
      {
        getRowId: (params) => String(params.data.variationId),
        defaultColDef: {
          sortable: false,
        },
        rowClassRules: {
          [ROW_DELETED_CLASS]: ({ data }: { data: DrawDetailsChangeOrder }) =>
            data.drawRuleId !== this.masterDrawRuleId,
        },
      });
    this.gridDefinition.bind(changeOrderGridLayout);
  }

}
